export const ENTITY_FIELD_DS_ENDPOINT = '/entityField'
export const THESAURUS_TERM_DS_ENTITY_NAME = 'thesaurusTerm'
export const ITEM_DS_ENTITY_NAME = 'items'
export const CONTAINER_TYPES_FOR_SEARCH = ['physicalContainerItem', 'numericContainerItem']
export const ACCESSORY_TYPES_FOR_SEARCH = ['numericAccessoryItem', 'physicalAccessoryItem']